import { useMemo } from 'react';
import { processConsecutiveBatches, calculateStatsFromBatches } from '../utils/dataProcessors';

export const useChartData = (healthMetrics, timeRangeType) => {
  const chartData = useMemo(() => {
    console.log('[useChartData] healthMetrics:', healthMetrics, 'timeRangeType:', timeRangeType);

    if (!healthMetrics?.metricsBatches?.length) {
      console.log('[useChartData] No batches → empty data');
      return processConsecutiveBatches([], timeRangeType);
    }

    // ✅ Pass timeRangeType here — this was the root cause of undefined
    return processConsecutiveBatches(healthMetrics.metricsBatches, timeRangeType);
  }, [healthMetrics, timeRangeType]);

  const stats = useMemo(() => calculateStatsFromBatches(chartData), [chartData]);

  const hasData = useMemo(() => chartData.some(d => !d.isEmptyData), [chartData]);

  return { chartData, hasData, stats };
};